import PaintProductionConfigWorkspace from '../../placeholders/PaintProductionConfigWorkspace';

export default PaintProductionConfigWorkspace;
